import { render, staticRenderFns } from "./IndexPackage.vue?vue&type=template&id=be23a0ca&scoped=true&"
import script from "./IndexPackage.vue?vue&type=script&lang=js&"
export * from "./IndexPackage.vue?vue&type=script&lang=js&"
import style0 from "./IndexPackage.vue?vue&type=style&index=0&id=be23a0ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be23a0ca",
  null
  
)

export default component.exports